import React, { useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@shared/ui/dialog";
import { DynamicForm } from "@shared/components/DynamicForm";
import { FormField, FormService } from "@shared/services/FormServices";

interface ViewPrintingDetailsModalProps {
  selectedCycle: any;
  openModal: boolean;
  openChangeModal: (open: boolean) => void;
}

const ViewPrintingDetailsModal = ({
  selectedCycle,
  openModal,
  openChangeModal,
}: ViewPrintingDetailsModalProps) => {

  const formFields: FormField[] = [
    {
      name: "printDate",
      type: "text",
      label: "Print Date",
      disabled: true,
      className: "col-span-2 mt-3",
    },
    {
      name: "status",
      type: "text",
      label: "Status",
      disabled: true,
      className: "col-span-2 mt-3",
    },
    {
      name: "vendor",
      type: "text",
      label: "Vendor",
      disabled: true,
      className: "col-span-1 mt-3",
    },
    {
      name: "lapsedDays",
      type: "text",
      label: "Lapsed Days",
      disabled: true,
      className: "col-span-1 mt-3",
    },
    {
      name: "notes",
      type: "textarea",
      label: "Notes",
      disabled: true,
      className: "col-span-2 mt-3",
    }
  ];

  const form = FormService.createForm({
    fields: formFields,
    mode: "onChange",
    validateOnMount: false,
    defaultValues: {
      printDate: "",
      status: "",
      vendor: "",
      lapsedDays: "",
      notes: "",
    },
  });

  useEffect(() => {
    if (openModal && selectedCycle) {
      const initialValues = {
        printDate: selectedCycle.printingDate || "NA",
        status: selectedCycle.printingStatus || "NA",
        vendor: selectedCycle.vendor?.vendorName || "Unassigned",
        lapsedDays: selectedCycle.lapsedDays
          ? `${selectedCycle.lapsedDays} days`
          : "0 days",
        notes: selectedCycle.notes || "No notes available.",
      };

      FormService.populateForm(form, initialValues, formFields);
    }
  }, [openModal, selectedCycle, form, formFields]);

  const handleClose = () => {
    form.reset();
    openChangeModal(false);
  };

  return (
    <Dialog open={openModal} onOpenChange={openChangeModal}>
      <DialogContent className="sm:max-w-[500px] max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-xl">Printing Details</DialogTitle>
          <DialogDescription>
            Details for {selectedCycle?.cycleName}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-6">
          <DynamicForm
            fields={formFields}
            form={form}
            onSubmit={handleClose}
            onReset={handleClose}
            gridColumns={2}
            responsiveColumns={{
              sm: 1,
              md: 2,
            }}
            config={{
              showResetButton: false,
              showSubmitButton: true,
              submitButtonText: "Close",
              spacing: "comfortable",
              classes: {
                container: "w-full mb-4",
                label: "block text-sm font-medium text-gray-700 mb-2",
                buttonContainer: "flex justify-end",
                input: "w-full h-11 px-3 border border-gray-300 rounded-lg bg-gray-50 text-gray-500",
                textarea: "w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-500 min-h-[80px]",
              },
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ViewPrintingDetailsModal;
